import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import urlHandler from '../../utils/urlHandler';
import validation from '../../utils/validation';
import ReactModal from 'react-modal';

class SendingProgress extends Component {
    render() {
        return (
            <div className="account-sending">
                <span className="fa fa-circle-o-notch fa-spin"></span>&nbsp;&nbsp;Sending ...
            </div>
        );
    }
}

class RequestAccountDialog extends Component {
    constructor(props){
        super(props);

        this.close = this.close.bind(this);
        this.open = this.open.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.reset = this.reset.bind(this);

        this.state = {
            error: '',
            sending: false,
            modalOpen: false
        };

        this.mailServerDisable = window._mailServerDisable;
    };

    componentDidMount() {
        ReactModal.setAppElement('#rm_RequestAccountDialog');
    }

    reset() {
        this.setState({ error: '', sending: false });
    };

    close() {
        this.setState({ 
            sending: false,
            modalOpen: false
         });
    };

    open() {
        this.reset();
        this.setState({
            modalOpen: true
        });
    };

    handleSubmit() {
        this.reset();

        const name = this.refs.name;
        const org = this.refs.org;
        const email = this.refs.email;

        if (name.value.length == 0) {
            this.setState({ error: 'Name required.' });
            name.focus();
            return;
        }
        else if (org.value.length == 0) {
            this.setState({ error: 'Company or organization required.' });
            org.focus();
            return;
        }
        else if (!validation.validEmail(email.value)) {
            this.setState({ error: 'Valid email address required.' });
            email.focus();
            return;
        }

        this.setState({sending: true});
        urlHandler.submitAccountRequest(
            {
                email: email.value,
                name: name.value,
                organization: org.value
            }
        ).then((response) => {
            console.log(response);
            this.close();
        });
    };

    render() {

       const styles = {
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.35)',
                overflow: 'hidden',
                height: '2000px',
                zIndex: '1000'
            },
            content : {
                top         : '35%',
                left        : '50%',
                marginRight : '-50%',
                paddingTop  : '35px',
                transform   : 'translate(-50%, -35%)',
                maxWidth    : '600px',
                height      : '100%',
                padding     : '0px',
                opacity     : '0.99',
                border      : '0px',
                background  : 'transparent',
                borderRadius: '0px 0px 5px 5px'
            }
        }

        return (
            <div id="rm_RequestAccountDialog">
                {!this.props.hidden && <button className="link-button" onClick={this.open}>
                    {this.props.renderIcon ? <span className='fa fa-sign-in'>&nbsp;&nbsp;</span> : null}
                    {this.props.renderText ? this.props.text : ''}
                </button>}
                <ReactModal ref="accountId"
                    isOpen={this.state.modalOpen} 
                    contentLabel="Account Request Form"
                    onRequestClose={this.close} 
                    style={styles}
                    closeTimeoutMS={1000}>
                    <div className="account-dialog">
                        <div className="account-header">
                            Account Request Form
                        </div>
                        <div className="account-description">
                            <span className='fa fa-sign-in account-icon'>&nbsp;</span>
                            Get access to powerful tools so you can test Finch for Text's disambigation capabilities
                            with your own documents and run live queries against our simple, powerful API.
                        </div>
                        <div className="account-content">
                            {this.mailServerDisable ?
                                <div className="account-form">
                                    Mail send disabled. Please contact Finch Computing (support@finchcomputing.com) or your administrator for further information.
                                    <br/><br/>
                                </div>
                            :
                                <div className="account-form">
                                    <div className='form-field-wrapper text-field'>
                                        <label htmlFor='nameField' className='form-label'>Name:</label>
                                        <input type='text'
                                                className='form-field account-form-field'
                                                name='name'
                                                id='nameField'
                                                ref='name'
                                                autoFocus
                                        />
                                    </div>
                                    <div className='form-field-wrapper text-field'>
                                        <label htmlFor='orgField' className='form-label'>Company/Organization:</label>
                                        <input type='text'
                                                className='form-field account-form-field'
                                                name='org'
                                                id='orgField'
                                                ref='org'
                                        />
                                    </div>
                                    <div className='form-field-wrapper text-field'>
                                        <label htmlFor='emailField' className='form-label'>Email Address:</label>
                                        <input type='text'
                                                className='form-field account-form-field'
                                                name='email'
                                                id='emailField'
                                                ref='email'
                                        />
                                    </div>
                                    <br/>
                                    <span className="account-error-msg">{this.state.error}</span>
                                    <br/>
                                </div>
                            }
                        </div>
                        <div className="account-footer">
                            {this.state.sending ? <SendingProgress /> : null}
                            <button type="button" className="account-default-button" onClick={this.handleSubmit} disabled={this.mailServerDisable}>Submit Request</button>
                            <button type="button" className="account-default-button" onClick={this.close}>Cancel</button>
                        </div>
                    </div>
                </ReactModal>
            </div>
        );
    };
}

RequestAccountDialog.defaultProps = {
    renderIcon: true,
    renderText: true,
    hidden:false,
    text: 'click'
};

export default RequestAccountDialog;

